import { Text, View } from "@react-pdf/renderer";

import { capitalize } from "~/common/utils";
import { ResponseTheme } from "~/providers/utils/types/patientPreviewTypes";

const THEME_COLORS = [
  {
    primary: "#323539",
    secondary: "#EAEBF0",
  },
  {
    primary: "#2433A8",
    secondary: "#C1D4FB",
  },
  {
    primary: "#203742",
    secondary: "#C2E4F5",
  },
  {
    primary: "#363F67",
    secondary: "#C8D0F9",
  },
  {
    primary: "#5E406D",
    secondary: "#F0D2FF",
  },
];

export const ConsultationExportSummaryThemes = ({
  responseThemes,
}: {
  responseThemes: ResponseTheme[];
}) => {
  if (!responseThemes.length) return null;

  const questionThemesByTheme = Object.groupBy(
    responseThemes,
    ({ question_theme }) => question_theme.code,
  );

  const themes = Array.from(
    new Map(
      responseThemes.map(({ question_theme }) => [
        question_theme.id,
        question_theme,
      ]),
    ).values(),
  )
    .filter((theme) => {
      return questionThemesByTheme[theme.code]?.some(
        ({ triggered }) => triggered,
      );
    })
    .sort((a, b) => a.order - b.order);

  return (
    <View style={{ border: "1px solid #C1C3C7", borderRadius: 6 }}>
      <View
        style={{
          flexDirection: "row",
          paddingVertical: 8,
          paddingHorizontal: 8,
          borderBottomWidth: 1,
          borderBottomColor: "#C1C3C7",
          backgroundColor: "#F0F4FE",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
        }}
      >
        <View style={{ width: "60%" }}>
          <Text style={{ color: "#2433A8" }}>Area to further explore</Text>
        </View>
        <View style={{ width: "40%" }}>
          <Text style={{ color: "#2433A8" }}>Why this appears</Text>
        </View>
      </View>

      {themes.map((theme, i) => {
        const questionThemes = questionThemesByTheme[theme.code]?.filter(
          ({ triggered }) => triggered,
        );

        return (
          <View
            style={{
              flexDirection: "row",
              paddingVertical: 8,
              paddingHorizontal: 8,
              borderBottomWidth: i === themes.length - 1 ? 0 : 1,
              borderBottomColor: "#C1C3C7",
            }}
            key={i}
            wrap={false}
          >
            <View
              style={{
                width: "60%",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              <Text
                style={{
                  backgroundColor:
                    THEME_COLORS[theme.order].secondary ||
                    THEME_COLORS[0].secondary,
                  color:
                    THEME_COLORS[theme.order].primary ||
                    THEME_COLORS[0].primary,
                  paddingHorizontal: 8,
                  paddingVertical: 2,
                  borderRadius: 20,
                  fontSize: 10,
                }}
                key={i}
              >
                {theme.name}
              </Text>
            </View>
            <View style={{ width: "40%" }}>
              {questionThemes?.map((qt, j) => (
                <View
                  key={j}
                  style={{ flexDirection: "column", width: "100%" }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginBottom: 4,
                      paddingRight: 8,
                      fontWeight: 400,
                    }}
                  >
                    <Text style={{ marginRight: 4 }}>•</Text>
                    <Text>
                      {qt.flow_node.question_text}
                      <Text> {"->"} </Text>
                      {capitalize(qt.condition_value)}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        );
      })}
    </View>
  );
};
